// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"22b02f07","977":"9884622c"}[chunkId] + ".chunk.js";
};